import {EntityState} from '@ngrx/entity';
import {SongEntity} from './entities/song-entity.model';

export type SongState = EntityState<SongEntity>;

export interface Song {
  id: string;
}
